export default __webpack_public_path__ + "static/media/logo-elipse.bd0577fa.png";